import {
  ComponentLabel,
  UiZoneWidgetConfig,
  WidgetNames,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export const mapIframeWidgetFunction = function mapIframeWidget(
  item: WorkflowWidgetConfig,
): UiZoneWidgetConfig {
  const elementsConfig = item.widgetConfiguration.attributes?.elementsConfig;
  const widgetAttr = item.widgetConfiguration?.attributes;
  return {
    name: item.name as ComponentLabel,
    attributes: {
      ...widgetAttr,
      showIFrameWidget:
        elementsConfig.find((item) => item.field_name === WidgetNames.IFRAME_WIDGET)?.show ?? true,
      iframeUrl: widgetAttr.css_config.iframeUrl ?? '',
      verticalHeight: widgetAttr.css_config.verticalHeight ?? '',
    },
    uniqueId: item.uniqueId,
    gridPosition: item.gridPosition,
  };
};
